import { Component, ViewChild } from '@angular/core';
import { CourseSideNavbarComponent } from '../course-side-navbar/course-side-navbar.component';
import { Router, RouterModule } from '@angular/router';
import { StudentNavbarQuizLessonComponent } from '@edtech-ui/student-dashboard-v2/student-navbar-quiz-lesson/student-navbar-quiz-lesson.component';

@Component({
	selector: 'app-pro-course-detail-page',
	standalone: true,
	imports: [CourseSideNavbarComponent, RouterModule, StudentNavbarQuizLessonComponent],
	templateUrl: './pro-course-detail-page.component.html',
	styleUrl: './pro-course-detail-page.component.scss'
})
export class ProCourseDetailPageComponent {

	@ViewChild(CourseSideNavbarComponent) sideNavbar!: CourseSideNavbarComponent;

	constructor(private router: Router) { }

	isQuizMode(): boolean {
		return this.router.url.includes('/detailed-solutions') || this.router.url.includes('/quiz/') || this.router.url.includes('attemptId=');
	}

	openMobileSidebar() {
		this.sideNavbar?.openSidebar();
	}
}
